import { render, staticRenderFns } from "./UpdateProductOrderShipmentPopUp.vue?vue&type=template&id=2a502c9a&scoped=true&"
import script from "./UpdateProductOrderShipmentPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateProductOrderShipmentPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateProductOrderShipmentPopUp.vue?vue&type=style&index=0&id=2a502c9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a502c9a",
  null
  
)

export default component.exports